/**
 * Immediate frontend check for mobile numbers before API normalisation.
 * Allows digits, an optional leading +, spaces, and hyphens.
 * Empty values pass so optional fields can use `required` separately.
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export default function phoneNumberValidation(value) {
  if (value == null || String(value).trim() === '') {
    return true;
  }

  const normalized = String(value).trim();

  if (!/^\+?[\d\s-]+$/.test(normalized)) {
    return false;
  }

  return /\d/.test(normalized);
}
